import React from 'react';
import { NavLink } from 'react-router-dom';
import { reactLocalStorage } from 'reactjs-localstorage';
import { FaTrash, FaPencilAlt, FaUser, FaFileAlt, FaPlus } from 'react-icons/fa';

import ProjectAPI from '../../api/ProjectAPI';
import ContactAPI from '../../api/ContactAPI';
import ApiUiController from '../../controller/ApiUiController';
import PropertyPopup from '../property/PropertyPopup';
import InnerPropertyList from '../property/InnerPropertyList';
import TowerPopup from '../tower/TowerPopup';
import InnerTowerList from '../tower/InnerTowerList';
import ProjectContactPopup from '../contact/ProjectContactPopup';
import InnerContactList from '../contact/InnerContactList';
import ProjectDetails from './ProjectDetails';
import ProjectInformation from './ProjectInformation';
import DocumentPopup from '../meeting/DocumentPopup';
import InnerDocumentList from '../document/InnerDocumentList';
import Util from '../../util/Util';
import withRouter from '../../util/WithRouter';
import Const from '../../util/Constants';
import ProjectConst from '../../util/ProjectConst';
import Display from '../../util/Display';

import './ProjectPreview.css';
import InnerProjectContactList from '../contact/InnerProjectContactList';

class ProjectPreview extends React.Component {

  static Inventory = 'module-project-inventory';

  static Refresh = 'refresh';
  static Property = 'property';
  static Tower = 'tower';
  static Contact = 'contact';
  static Document = 'document';
  
  constructor(props) {
    super(props);
    
    this.models = reactLocalStorage.getObject(Const.Model);
    this.model = this.models.project;
    this.id = parseInt(props.match.params.projectId);
    this.user = reactLocalStorage.getObject(Const.LoggedInUser);
    this.base = this.props.match.path
    this.base = this.base.substring(0, this.base.indexOf('/preview'));
    
    this.state = { inApiCall: this.id !== 0 , popup: null,
      property: null, tower: null,  meeting: null, document: null, email: 0, sms: 0, whatsApp: 0 };

    this.Update = Util.isAllow(this.model.permission, Const.PermUpdate);
    this.Delete = Util.isAllow(this.model.permission, Const.PermDelete);

    this.ContactList = Util.isAllow(this.models.contact.permission, Const.PermView);
    this.ContactAdd = Util.isAllow(this.models.contact.permission, Const.PermAdd);
    
    this.DocList = Util.isAllow(this.models.document.permission, Const.PermView);
    this.DocAdd = Util.isAllow(this.models.document.permission, Const.PermAdd);

    this.HideAllContact = Util.isAllow(this.models.project.permission, Const.HideAllContact);
    this.HideOthersContact = Util.isAllow(this.models.project.permission, Const.HideOtherContact);
    this.HideOtherContactView = false;

    this.ConfigAdd = Util.isAllow(this.models.property.permission, Const.PermAdd);

    this.IsInventory = reactLocalStorage.get(Const.ProjectInventory);
    this.TowerList = Util.isAllow(this.models.tower_details.permission, Const.PermView);
    this.TowerAdd = Util.isAllow(this.models.tower_details.permission, Const.PermView);
  }

  UNSAFE_componentWillReceiveProps(props) {
    if(this.id !== parseInt(props.match.params.projectId)) {
      this.id = parseInt(props.match.params.projectId);
      let dummy = { ...this.state };
      if(dummy.document) { dummy.document.model_no = Const.Project; dummy.document.model_id = this.id; }
      if(dummy.tower) { dummy.tower.model_no = Const.Project; dummy.tower.model_id = this.id; }
      this.setState({ ...dummy });
      ProjectAPI.get(this.id, this.onReceived, this.props.failure, this.props.logout);
    }
  }

  componentDidMount() { 
    if(this.id !== 0) {
      ProjectAPI.get(this.id, this.onReceived, this.props.failure, this.props.logout);
    }
  }

  onReceived = (res) => {
    this.project = res;
    if(this.HideOthersContact) {
      if(!this.project.responsible_person.includes('~'+this.user.user_id+'~')) {
        this.HideOtherContactView = true;
      }
    }
    this.setState({ ...this.state, inApiCall: false });
  }

  onUpdate = () => {
    this.setState({ ...this.state, inApiCall: true });
    ProjectAPI.get(this.id, this.onReceived, this.props.failure, this.props.logout);
  };
  onDelete = () => Util.confirmAlert('Delete', `Are you sure you want to delete to`
    + ` ${Display.ModelName(this.lead)}`, 'Delete', 'No', () => {
      this.setState({ ...this.state, inApiCall: true });
      ProjectAPI.delete(this.lead.id, this.onDeleteSuccess,
        this.props.failure, this.props.logout);
  });
  onDeleteSuccess = () => {
    Util.showNotification('Successful', 'Project deleted successfully', 'success');
    this.props.navigate('/project');
  }

  updateMater = () => {
    this.setState({ inApiCall: true, popup: null });
    ProjectAPI.get(this.id, this.onReceived, this.props.failure, this.props.logout);
  }

  showDetails = (model, field) => {
    if(field === ProjectConst.SalesOrder) {
      this.props.navigate(`/sales-order/preview/${model}`);
      return;
    } else if(field === ProjectConst.Contact) {
      this.props.navigate(`/contact/preview/${model}`);
      return;
    }
  }
  showPopUp = (model, field) => {
    let tmp = {...this.state};
    tmp[field] = model;
    tmp.popup = field;
    this.setState({ ...tmp});
  }

  hidePopUp = () => this.setState({ ...this.state, popup: ProjectConst.Refresh});
  redirectAddContact = id => this.props.navigate(`/contact/add-edit/${id}`);
  addContact = contactData => {
    this.setState({ inApiCall: true, popup: null });
    contactData.project = this.id;
    ContactAPI.addProjectContact(contactData, this.onReceived, this.props.failure, this.props.logout);
  };
  
  render() {
    let param = { };
    const ProjectContactPopUp = this.ContactAdd ?
      <ProjectContactPopup show={this.state.popup === ProjectConst.Contact} onHide={this.hidePopUp}
        redirect={this.redirectAddContact} addContact={this.addContact} />
      : null;
    const ContactButton = (this.HideAllContact || this.HideOtherContactView) ? null : (this.ContactAdd ?
      <span className="buttons sales" variant="primary"
        onClick={() => this.showPopUp(null, ProjectConst.Contact)}><FaUser /> Owner Details
      </span> : null);
    const ContactList = (this.HideAllContact || this.HideOtherContactView)  ? null : (this.ContactList ?
     <InnerProjectContactList id={this.id} type={Const.Project} {...param} onLoad={this.onLoadContacts}
       reload={this.updateMater} show={this.showDetails} edit={this.redirectAddContact} title="Owner Details" /> : null);

    const DocumentPopUp = this.DocAdd ?
       <DocumentPopup show={this.state.popup === ProjectConst.Document} onHide={this.hidePopUp}
         document={this.state.document} reload={this.updateMater} model_no={Const.Project} 
         model_id={this.id} title="Add Image" /> : null;
    const DocumentButton = this.DocAdd ?
      <span className="buttons junk" variant="primary"
        onClick={() => this.showPopUp(null, ProjectConst.Document)}><FaFileAlt /> Add Image
      </span> : null;
    const DocList = this.DocList ?
      <InnerDocumentList id={this.id} type={Const.Project} {...param} 
      reload={this.updateMater} title="Images" /> : null;

    return (
      <section className="previewpage"> 
        {ProjectContactPopUp} {DocumentPopUp}
        <ApiUiController inApiCall={this.state.inApiCall}>
          
          <PropertyPopup show={this.state.popup === ProjectConst.Property} onHide={this.hidePopUp}
            property={this.state.property} failure={this.props.failure} logout={this.props.logout}
            reload={this.updateMater} model_no={Const.Project} model_id={this.id} project={this.project} />

          <TowerPopup show={this.state.popup === ProjectConst.Tower} onHide={this.hidePopUp}
            tower={this.state.tower} failure={this.props.failure} logout={this.props.logout}
            reload={this.updateMater} model_no={Const.Project} model_id={this.id} project={this.project} />
        
          <div className="container-fluid">  
            <div className="row lead-mt">
              <div className="col-md-4">
                <div className="title_page"><h2>Project - {this.project && this.project.project_name}</h2></div>
              </div>
              <div className="col-md-8 lead-btns-col">
                <span className="action-btns-lg">
                  { this.ConfigAdd ?
                    <span className="buttons call" variant="primary"
                      onClick={() => this.showPopUp(null, ProjectConst.Property)}>
                      <FaPlus /> Add Configuration
                    </span>
                    : null
                  }
                  { this.IsInventory && this.TowerAdd ?
                    <span className="buttons success" variant="success"
                      onClick={() => this.showPopUp(null, ProjectConst.Tower)}><FaPlus /> Add Tower
                    </span>
                    : null
                  }
                  { this.Update ?
                    <span className="buttons update" variant="primary">
                      <NavLink to={`${this.base}/add-edit/${this.id}`}><FaPencilAlt /> Update</NavLink>
                    </span>
                    : null
                  }
                  { 
                    this.Delete ? <span className="buttons delete" onClick={this.onDelete}><FaTrash/> Delete</span>
                    : null
                  }
                  {DocumentButton} {ContactButton}
                </span>
              </div>
            </div>

            <div className="row tablesrow">
              <div className="col-md-12">
                <ProjectDetails model={this.model} project={this.project} ProjectName={this.project && this.project.project_name} />
                <ProjectInformation model={this.model} project={this.project} />
                <InnerPropertyList id={this.id} type={Const.Project} reload={this.updateMater}
                  edit={this.showPopUp} logout={this.props.logout} failure={this.props.failure} />
                { this.IsInventory && this.TowerList ?
                  <InnerTowerList id={this.id} type={Const.Tower} {...param} reload={this.updateMater}
                    edit={this.showPopUp} logout={this.props.logout} failure={this.props.failure} 
                    model_no={Const.Project} model_id={this.id} project={this.project} />
                  : null
                }
                {DocList} {ContactList}
              </div>
            </div>
          </div>
        </ApiUiController>
      </section>
    );
  }
}
export default withRouter(ProjectPreview);